// src/services/pixService.js

/**
 * Gera um código PIX estático (para testes)
 * Em produção, use uma API real como:
 * - Mercado Pago
 * - PagSeguro
 * - Gerencianet
 */
export const generatePixCode = (paymentData) => {
  const { value, description, recipient, city } = paymentData;
  
  // Formata valor para string com 2 decimais
  const formattedValue = value.toFixed(2);
  
  // Informações do beneficiário (sua barbearia)
  const merchantName = recipient || "BARBEARIA XPTO LTDA";
  const merchantCity = city || "SAO PAULO";
  const pixKey = "barbearia@email.com"; // Chave PIX da sua barbearia
  
  // Gera payload PIX no formato BR Code
  const payload = [
    '000201', // Payload Format Indicator
    '010212', // Point of Initiation Method (12 = static)
    '26', // Merchant Account Information length
    '0014BR.GOV.BCB.PIX', // GUI
    `01${pixKey.length.toString().padStart(2, '0')}${pixKey}`, // Chave PIX
    '52040000', // Merchant Category Code (0000 = não especificado)
    '5303986', // Transaction Currency (986 = BRL)
    `54${formattedValue.length.toString().padStart(2, '0')}${formattedValue}`, // Transaction Amount
    '5802BR', // Country Code
    `59${merchantName.length.toString().padStart(2, '0')}${merchantName}`, // Merchant Name
    `60${merchantCity.length.toString().padStart(2, '0')}${merchantCity}`, // Merchant City
    '6207', // Additional Data Field Template
    `05${description.length.toString().padStart(2, '0')}${description}`, // Reference Label
    '6304' // CRC16
  ].join('');
  
  // Calcula CRC16 (simplificado - em produção use biblioteca)
  const crc = calculateCRC16(payload);
  
  return `${payload}${crc}`;
};

/**
 * Calcula CRC16 (versão simplificada para demonstração)
 * Em produção, use uma biblioteca como crc-16
 */
const calculateCRC16 = (payload) => {
  // Implementação simplificada - em produção use biblioteca
  const crcTable = [
    0x0000, 0x1021, 0x2042, 0x3063, 0x4084, 0x50A5, 0x60C6, 0x70E7,
    0x8108, 0x9129, 0xA14A, 0xB16B, 0xC18C, 0xD1AD, 0xE1CE, 0xF1EF
  ];
  
  let crc = 0xFFFF;
  
  for (let i = 0; i < payload.length; i++) {
    const byte = payload.charCodeAt(i);
    crc = (crc << 4) ^ crcTable[((crc >> 12) ^ (byte >> 4)) & 0x0F];
    crc = (crc << 4) ^ crcTable[((crc >> 12) ^ (byte & 0x0F)) & 0x0F];
  }
  
  return (crc & 0xFFFF).toString(16).toUpperCase().padStart(4, '0');
};

/**
 * Gera dados para QR Code PIX
 */
export const generatePixQRCodeData = (paymentData) => {
  const pixCode = generatePixCode(paymentData);
  
  return {
    code: pixCode,
    qrCodeText: `00020126360014BR.GOV.BCB.PIX0114${paymentData.pixKey || 'barbearia@email.com'}52040000530398654${paymentData.value.toFixed(2)}5802BR5925BARBEARIA XPTO LTDA6009SAO PAULO62070503***6304`,
    value: paymentData.value,
    description: paymentData.description,
    expiration: new Date(Date.now() + 24 * 60 * 60 * 1000) // 24 horas
  };
};

/**
 * Validação de pagamento PIX (simulação)
 */
export const simulatePixPayment = async (paymentId, value) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Simula uma confirmação de pagamento
      const success = Math.random() > 0.2; // 80% de sucesso
      
      if (success) {
        resolve({
          success: true,
          txid: `PIX${Date.now()}${Math.random().toString(36).substr(2, 9)}`,
          message: 'Pagamento confirmado com sucesso!'
        });
      } else {
        resolve({
          success: false,
          message: 'Pagamento não confirmado. Tente novamente.'
        });
      }
    }, 2000); // Simula 2 segundos de processamento
  });
};